import { AdditionalReasonFieldProps } from './AdditionalReasonField'
import { RawSelectField } from '@components/ui/formElements/form/selectFields/RawSelectField'

export const ReasonDropdown = ({
  field,
  values,
  handleOnAdditionalReasonSelection
}: AdditionalReasonFieldProps) => {
  const handleSelect = (selection: string) => {
    if (selection) {
      handleOnAdditionalReasonSelection([selection])
    }
  }

  const reasonList =
    field?.values.map(({ label, value }) => ({
      label,
      value,
      available: true
    })) || []
  const reasonListValues = reasonList.map(({ value }) => value)
  const selectedReason: string =
    values.reason_detail?.find(id => reasonListValues.includes(id)) || ''

  return (
    <RawSelectField
      id="reason_dropdown"
      options={reasonList}
      name="reason_dropdown"
      placeholder="Please Select"
      settings={{ label: { visible: false } }}
      value={selectedReason}
      setValue={handleSelect}
    />
  )
}
